(function () {
  document.querySelectorAll('.oi-breadcrumbs').forEach(function (nav) {
    var items = nav.querySelectorAll('.breadcrumb-item');
    var prev = nav.querySelector('.breadcrumb-prev');
    var next = nav.querySelector('.breadcrumb-next');
    var current = items.length - 1;

    function show(index) {
      current = index;
      items.forEach(function (item) { item.classList.remove('_active'); });
      items[current].classList.add('_active');
      prev.classList.toggle('_hidden', current === 0);
      prev.setAttribute('aria-hidden', current === 0);
      next.classList.toggle('_hidden', current === items.length - 1);
      next.setAttribute('aria-hidden', current === items.length - 1);
    }

    prev.addEventListener('click', function () { if (current > 0) show(current - 1); });
    next.addEventListener('click', function () { if (current < items.length - 1) show(current + 1); });

    show(current);
  });
})();
